import React, { useState } from 'react';
import { deleteAccount } from '../services/accountService';
import './comic.css';

/**
 * Account-level (not Hero-level) destructive action, alongside Privacy
 * Policy/Terms of Service as the third of "the three links." Two call
 * sites: App.js's footer (for the pre-tab-bar states -- logged out, or
 * logged in but not yet past UsernameGate/EmailVerificationGate/
 * ProfileGate, none of which render ProfileSwitcher, so this still needs a
 * way to be reachable there) and, once tabs exist, inside
 * ProfileSwitcher.jsx's expanded panel instead (moved there 2026-08-18 per
 * direct user request). Collapsed to a small text link matching its
 * siblings' muted styling by default; expands into an inline confirmation
 * panel requiring the current password (Firebase requires a "recent login"
 * for account deletion, and re-confirming the password doubles as a safety
 * check before an irreversible action). On success there's nothing further
 * to do here -- App.js's onAuthStateChanged listener picks up the
 * now-signed-out state and swaps to the Login screen on its own.
 */
const DeleteAccount = () => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const close = () => {
    setOpen(false);
    setPassword("");
    setSubmitting(false);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || submitting) return;

    setSubmitting(true);
    setError(null);
    const result = await deleteAccount(password);
    if (!result.success) {
      setSubmitting(false);
      setError(result.error);
    }
    // On success, this component is about to unmount as the app swaps to
    // the Login screen -- no local state to reset.
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          font: "inherit",
          color: "#888",
          textDecoration: "underline",
          cursor: "pointer"
        }}
      >
        Delete My Account
      </button>
    );
  }

  return (
    <div className="comic-panel" style={{ marginTop: "10px", padding: "14px", borderColor: "#fd874e" }}>
      <p style={{ margin: "0 0 10px 0", fontFamily: "'Anonymous Pro', monospace", fontSize: "14px", color: "#232526" }}>
        This permanently deletes your account: all Heroes, logged workouts, routines, custom
        exercises, and uploaded photos. This can't be undone.
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Confirm your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="comic-input"
          style={{ width: "100%", marginBottom: "10px" }}
          autoFocus
        />
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            type="submit"
            disabled={!password || submitting}
            className="comic-btn comic-btn--end"
            style={{ flex: 1 }}
          >
            {submitting ? "Deleting..." : "Delete My Account"}
          </button>
          <button
            type="button"
            onClick={close}
            disabled={submitting}
            className="comic-btn comic-btn--done"
            style={{ flex: 1 }}
          >
            Cancel
          </button>
        </div>
        {error && <div className="comic-alert-bubble">{error}</div>}
      </form>
    </div>
  );
};

export default DeleteAccount;
